import React, { useEffect } from 'react';
import { useCurrencyStore, formatPriceIn } from '../stores/currencyStore';

// Client/global state now lives in a Zustand store (stores/currencyStore.js).
// This hook + provider are kept as a stable shim so existing consumers
// (`useCurrency()`, `<CurrencyProvider>`) don't change.
export const useCurrency = () => {
  const currency = useCurrencyStore((s) => s.currency);
  const currencySymbol = useCurrencyStore((s) => s.currencySymbol);
  const region = useCurrencyStore((s) => s.region);
  const loading = useCurrencyStore((s) => s.loading);
  const detected = useCurrencyStore((s) => s.detected);
  const paymentSupported = useCurrencyStore((s) => s.paymentSupported);

  const formatPrice = (amount, showSymbol = true) => formatPriceIn(currency, amount, showSymbol);

  return { currency, currencySymbol, region, loading, detected, paymentSupported, formatPrice };
};

export const CurrencyProvider = ({ children }) => {
  const detect = useCurrencyStore((s) => s.detect);
  useEffect(() => { detect(); }, [detect]);
  return <>{children}</>;
};

export default CurrencyProvider;
